import React, { useState } from "react";
import { ModelCard } from "@/pages/chatbot/ai_settings/ModelCard.tsx";
import { ScrollArea } from "@/components/shadcn/scroll-area.tsx";
import { Input } from "@/components/shadcn/input";
import { useTranslation } from "react-i18next";
import { constants } from "@/constants";

export interface Model {
  id: string;
  name: string;
  description: string;
  credits: number;
  created: number;
  price: {
    input: number;
    output: number;
    generation: number;
    currency: string;
  };
}

interface Provider {
  label: string;
  filter: string;
  logo: string;
}

const providers: Provider[] = [
  { label: "OpenAI", filter: "openai", logo: "openai.svg" },
  { label: "Claude", filter: "anthropic", logo: "claude.svg" },
  { label: "Google Gemini", filter: "google", logo: "gemini.svg" },
  { label: "Grok", filter: "x-ai", logo: "grok.svg" },
  { label: "DeepSeek", filter: "deepseek", logo: "deepseek.svg" },
  { label: "Qwen", filter: "qwen", logo: "qwen.svg" },
  { label: "Cohere", filter: "cohere", logo: "cohere.svg" },
  { label: "Mistral", filter: "mistral", logo: "mistral.svg" },
];

interface ModelListProps {
  models: Model[];
  onModelChange: (model: Model) => void;
}

export function ModelList({
  models,
  onModelChange,
}: ModelListProps): JSX.Element {
  const { t } = useTranslation();
  const [provider, setProvider] = useState<Provider | null>(providers[0]);
  const [search, setSearch] = useState<string>("");

  return (
    <>
      <div>
        <Input
          placeholder={t("models.search")}
          onChange={(event: any) => {
            setSearch(event.target.value.toLowerCase());
          }}
        />
      </div>
      <div className="space-y-1">
        {providers.map((providerBtn: Provider, i: number) => {
          return (
            <span
              key={i}
              className={`inline-flex items-center mr-2 rounded-xl border py-2 px-2 cursor-pointer select-none ${
                providerBtn.label == provider?.label
                  ? "bg-slate-600 text-white"
                  : "hover:bg-gray-100"
              }`}
              onClick={() => {
                setProvider(providerBtn);
              }}
            >
              {providerBtn.logo && (
                <img
                  src={`${constants.baseURL}/logo/ai_brands/${providerBtn.logo}`}
                  alt=""
                  className={`opacity-80 align-middle w-[24px] mr-2 ${
                    providerBtn.label == provider?.label ? "invert" : ""
                  }`}
                />
              )}
              <span className="align-middle">{providerBtn.label}</span>
            </span>
          );
        })}
      </div>
      <ScrollArea className="md:pr-4 md:mr-[-16px]">
        {models.map((model: Model, i: number) => {
          if (
            (search &&
              (model.id.includes(search) ||
                model.name.toLowerCase().includes(search))) ||
            (!search && provider && model.id.startsWith(provider.filter))
          ) {
            return (
              <ModelCard
                key={i}
                model={model}
                showDesc={true}
                onModelChange={onModelChange}
              />
            );
          }

          return;
        })}
      </ScrollArea>
    </>
  );
}
